
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import formatPriceToTenge from '@/modern/helpers/formatPriceToTenge'

export default defineComponent({
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        balance: {
            type: String as PropType<string | null>,
            default: 0
        }
    },
    emits: ['open-history', 'top-up'],
    setup(props, { emit }) {
        const onOpenHistory = () => {
            if (props.loading) return
            emit('open-history')
        }

        const onTopUp = () => {
            if (props.loading) return
            emit('top-up')
        }

        return {
            formatPriceToTenge,
            onOpenHistory,
            onTopUp
        }
    }
})
